<template>
  <div v-scrollspy="{targets, direction}" class="scroll-spy" :style="styles">
    <slot></slot>
  </div>
</template>

<script>
import scrollspy from '../../directives/scroll-spy'

export default {
  name: 'TScrollSpy',
  directives: { scrollspy },
  props: {
    targets: {
      type: Array,
      default() {
        return []
      }
    },
    direction: {
      type: String,
      default: 'y',
      validator(val) {
        return ['x', 'y'].includes(val)
      }
    },
    height: {
      type: String,
      default: '100%',
      validator(val) {
        return val === '100%' || /^\d+px$/.test(val)
      }
    },
    width: {
      type: String,
      default: '100%',
      validator(val) {
        return val === '100%' || /^\d+px$/.test(val)
      }
    }
  },
  computed: {
    styles() {
      return [
        { 'overflow': 'hidden' },
        {
          [this.direction === 'y' ? 'overflow-y' : 'overflow-x']: 'auto'
        },
        { width: this.width },
        { height: this.height }
      ]
    },
    innerStyles() {
      return [
        this.direction === 'y' ? { width: this.width }
          : { height: this.height }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/scroll-spy/scroll-spy.vue